module.exports = __webpack_public_path__ + "static/media/america-tijuana.7cdd87fe.mp4";